import { render } from "./FooterTag.vue?vue&type=template&id=cbabfaa4&scoped=true"
const script = {}

import "./FooterTag.vue?vue&type=style&index=0&id=cbabfaa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbabfaa4"]])

export default __exports__